// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ApiParameter, get, HasPagingParameters } from "@insite/client-framework/Services/ApiService";
import { BaseModel, PaginationModel } from "@insite/client-framework/Types/ApiModels";
import { ReorderPadItemModel } from "@steiner/App/Store/Reducers";

const getReorderPadsUrl = "/api/str/ReorderPad/Items";

export interface ReorderPadApiParameter extends ApiParameter, HasPagingParameters {
    customerPartNumber?: string;
    customerSequence?: string;
    fromDate?: string;
    mfgrNumber?: string;
    productDescription?: string;
    sortBy?: string;
    toDate?: string;
}

export interface ReorderPadModel extends BaseModel {
    reorderPadItemList?: ReorderPadItemModel[];
    pagination: PaginationModel | null;
}

export async function getReorderPad(data: ReorderPadApiParameter): Promise<ReorderPadModel> {
    const reorderPad = await get<ReorderPadModel>(getReorderPadsUrl, data);
    return reorderPad;
}
